import Flag from 'components/Flag'
import * as S from './index.style'
import theme from 'styles/theme'
import { Button, Tab, Tabs } from '@material-ui/core'
import { buscarTerrenoPorId } from 'services/terrenos.service'
import { Terreno } from 'models/Terreno/Terreno'
import { Guid } from 'guid-typescript'
import { useEffect } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import React from 'react'
import { setarToken } from 'services/api.service'
import BackButton from 'components/BackButton'
import NomeTerreno from 'components/NomeTerreno'
import { Add } from '@styled-icons/material-rounded/Add'
import { TerrenoSituacao } from 'models/Terreno/TerrenoSituacao'
import { CasasSimplificado } from 'models/Viabilidade/CasasSimplificado'
import { buscarViabilidadesPorIdTerreno } from 'services/viabilidadeCasas.service'
import CartaoViabilidade from 'components/Viabilidades/CartaoViabilidade'
import Progress from 'components/Progress'
import { processandoDados } from 'helpers/Constantes/Mensagens'
import Erro from 'components/Erro'
import { TipoSituacaoEnum } from 'models/Viabilidade/Enum/TipoSituacaoEnum'
import { TipoFaseViabilidadeEnum, TipoFaseViabilidadeLabel } from 'models/Viabilidade/Enum/TipoFaseViabilidadeEnum'

export interface IViabilidadeRoutParams {
  idTerreno: string
}

export const Viabilidade: React.FC = () => {
  const history = useHistory()
  const { search } = useLocation()
  const { idTerreno } = useParams<IViabilidadeRoutParams>()
  const token: string | null = new URLSearchParams(search).get('token')
  const idEmpreendimento: string | null = new URLSearchParams(search).get('idEmpreendimento')
  const [fase, setFase] = React.useState<string | null>(new URLSearchParams(search).get('fase'))
  const [terreno, setTerreno] = React.useState<Terreno>()
  const [viabilidades, setViabilidades] = React.useState<CasasSimplificado[]>()
  const [ocorreuErro, setOcorreuErro] = React.useState(false)

  useEffect(() => {
    setarToken(token)
    const buscarTerreno = async (idTerreno: Guid) => {
      await buscarTerrenoPorId(idTerreno)
        .then((respostaApi: { isSuccess: boolean; entity: unknown }) => {
          setTerreno(respostaApi.entity as Terreno)
        })
        .catch(() => {
          setOcorreuErro(true)
        })
    }
    buscarTerreno(Guid.parse(idTerreno))
  }, [idTerreno, token])

  useEffect(() => {
    const buscarViabilidades = async (idTerreno: Guid) => {
      await buscarViabilidadesPorIdTerreno(idTerreno, idEmpreendimento ? Guid.parse(idEmpreendimento.valueOf()) : undefined)
        .then((viabilidades: CasasSimplificado[]) => {
          setViabilidades(viabilidades)
        })
        .catch(() => {
          setOcorreuErro(true)
        })
    }
    buscarViabilidades(Guid.parse(idTerreno))
  }, [idTerreno, idEmpreendimento])

  const terrenoFoiComprado = (): boolean => {
    if (
      terreno?.situacao === TerrenoSituacao.Comprado ||
      terreno?.situacao === TerrenoSituacao.EmEstudo ||
      terreno?.situacao === TerrenoSituacao.ProjetoEmDesenvolvimento ||
      terreno?.situacao === TerrenoSituacao.EmAprovacaoNaPrefeitura ||
      terreno?.situacao === TerrenoSituacao.ProjetoAprovado ||
      terreno?.situacao === TerrenoSituacao.ProjetoLegalizado ||
      terreno?.situacao === TerrenoSituacao.ObraIniciada ||
      terreno?.situacao === TerrenoSituacao.ObraEncerrada
    ) {
      return true
    }
    return false
  }

  const obterDataCompra = () => {
    let dataCompra = terreno?.previsaoFechamento
    if (!terrenoFoiComprado()) {
      dataCompra = undefined
    }

    return dataCompra
  }

  const goToNovaViabilidade = () => {
    const dataCompra = obterDataCompra()

    history.push('viabilidades/nova-viabilidade', {
      nomeTerreno: terreno?.nome,
      areaTerreno: terreno?.area,
      dataCompraTerreno: dataCompra,
      token: token,
      fase: fase,
      idEmpreendimento: idEmpreendimento
    })
  }

  const goToResultadoViabilidade = (idViabilidade: Guid, situacaoViabilidade: number) => {
    if (situacaoViabilidade === TipoSituacaoEnum.Rascunho) {
      goToNovaViabilidadeRascunho(idViabilidade, situacaoViabilidade)
    } else {
      history.push(`viabilidades/${idViabilidade.toString()}`, {
        nomeTerreno: terreno?.nome,
        idViabilidade: idViabilidade.toString(),
        token: token,
        situacao: situacaoViabilidade,
        areaTerreno: terreno?.area,
        dataCompraTerreno: obterDataCompra(),
        fase: fase,
        idEmpreendimento: idEmpreendimento
      })
    }
  }

  const goToNovaViabilidadeRascunho = (idViabilidade: Guid, situacaoViabilidade: number) => {
    const dataCompra = obterDataCompra()
    history.push('viabilidades/nova-viabilidade', {
      nomeTerreno: terreno?.nome,
      areaTerreno: terreno?.area,
      dataCompraTerreno: dataCompra,
      token: token,
      idViabilidade: idViabilidade,
      situacaoViabilidade: situacaoViabilidade,
      fase: fase,
      idEmpreendimento: idEmpreendimento
    })
  }

  const goToKanbamViabilidades = (): void => {
    parent.postMessage('Fechar viabilidade casas', '*')
  }

  const trocarFase = (novaFase: string): void => {
    const paramIdEmpreendimento = idEmpreendimento ? `&idEmpreendimento=${idEmpreendimento}` : ''
    history.replace({ pathname: location.pathname, search: `?fase=${novaFase}${paramIdEmpreendimento}&token=${token}` })

    setFase(novaFase)
  }

  const listaViabilidades = (viabilidades: CasasSimplificado[]) => {
    return viabilidades
      .filter((v) => v.fase === Number(fase))
      .map((viabilidade) => (
        <CartaoViabilidade
          onClickViabilidadeHandler={goToResultadoViabilidade}
          dados={viabilidade}
          nomeTerreno={terreno?.nome}
          areaTerreno={terreno?.area}
          dataCompraTerreno={obterDataCompra()}
          token={token}
          key={viabilidade.id.toString()}
          fase={Number(fase)}
          idEmpreendimento={idEmpreendimento}
        />
      ))
  }

  const possuiViabilidadeFase = (viabilidades: CasasSimplificado[] | undefined, tipoFaseViabilidade: number): boolean => {
    if (viabilidades) {
      return viabilidades.filter((v) => v.fase == Number(tipoFaseViabilidade)).length != 0
    }
    return false
  }

  return (
    <S.Wrapper>
      <S.Cabecalho>
        <S.CabecalhoRowUm>
          <S.DivFlex>
            <BackButton titulo="Viabilidade de Casas" onClick={goToKanbamViabilidades} />
          </S.DivFlex>
          {!ocorreuErro && (
            <S.DivRight>
              <Button
                data-cy="btnNovaViabilidade"
                variant="contained"
                style={{ height: '40px' }}
                color="secondary"
                startIcon={<Add size={24} />}
                onClick={goToNovaViabilidade}
              >
                Nova Viabilidade
              </Button>
            </S.DivRight>
          )}
        </S.CabecalhoRowUm>
        {!ocorreuErro && (
          <S.CabecalhoRowDois data-cy="divDadosTerreno">
            <NomeTerreno nomeTerreno={terreno?.nome} />
            <Flag text={terreno?.situacaoDescricao} backgroundColor={theme.colors.yellow} />
          </S.CabecalhoRowDois>
        )}
      </S.Cabecalho>

      <Tabs value={fase} variant="scrollable" scrollButtons="on" indicatorColor="primary" textColor="primary">
        {Object.keys(TipoFaseViabilidadeEnum)
          .filter((e) => !isNaN(Number(e)))
          .map((tipoFaseViabilidade) => (
            <Tab
              key={`tab${tipoFaseViabilidade}`}
              label={TipoFaseViabilidadeLabel.get(Number(tipoFaseViabilidade))}
              value={tipoFaseViabilidade}
              onClick={() => trocarFase(tipoFaseViabilidade)}
              data-cy={`tabFase${tipoFaseViabilidade}`}
              disabled={!possuiViabilidadeFase(viabilidades, Number(tipoFaseViabilidade))}
            />
          ))}
      </Tabs>

      <S.Content data-cy="divViabilidades">
        {ocorreuErro ? <Erro /> : viabilidades ? listaViabilidades(viabilidades) : <Progress label={processandoDados} />}
      </S.Content>
    </S.Wrapper>
  )
}
